<template>
    <div class="row">
        <div class="col-xs-12" @click="goBack">
            <div class="back-button">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M17.8132 10.0008C17.8132 10.2495 17.7145 10.4879 17.5387 10.6638C17.3628 10.8396 17.1244 10.9383 16.8757 10.9383H5.39136L9.41636 14.9626C9.59248 15.1387 9.69143 15.3776 9.69143 15.6266C9.69143 15.8757 9.59248 16.1146 9.41636 16.2907C9.24024 16.4668 9.00137 16.5658 8.7523 16.5658C8.50323 16.5658 8.26436 16.4668 8.08824 16.2907L2.46324 10.6657C2.37584 10.5786 2.30649 10.4751 2.25917 10.3611C2.21186 10.2472 2.1875 10.125 2.1875 10.0016C2.1875 9.87824 2.21186 9.75606 2.25917 9.64211C2.30649 9.52815 2.37584 9.42466 2.46324 9.33756L8.08824 3.71256C8.17544 3.62536 8.27897 3.55618 8.39291 3.50899C8.50685 3.46179 8.62897 3.4375 8.7523 3.4375C8.87563 3.4375 8.99775 3.46179 9.11169 3.50899C9.22563 3.55618 9.32916 3.62536 9.41636 3.71256C9.50357 3.79977 9.57275 3.9033 9.61994 4.01724C9.66714 4.13118 9.69143 4.2533 9.69143 4.37663C9.69143 4.49995 9.66714 4.62207 9.61994 4.73601C9.57275 4.84995 9.50357 4.95348 9.41636 5.04069L5.39136 9.06334H16.8757C17.1244 9.06335 17.3628 9.16212 17.5387 9.33793C17.7145 9.51375 17.8132 9.7522 17.8132 10.0008Z" fill="#87919F"/>
                </svg>
                <span>{{ $t('BACK_BUTTON') }}</span>
            </div>
        </div>
    </div>
</template>
<!---------------------------------------------------------------------------->
<script>
    export default {
        props: {
            backRoute: {
                type: [String, Object],
                default: null,
            },
        },
        methods: {
            goBack() {
                if (this.backRoute) {
                    this.$router.push(this.backRoute);
                } else {
                    this.$router.back();
                }
            },
        },
    };
</script>
<!---------------------------------------------------------------------------->
<style lang="scss" type="text/scss">
</style>
